import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

router.afterEach((to) => {
  document.title = to.meta.title || "Panel de Administración";
});

app.use(router);
app.mount("#app");
